import { render, staticRenderFns } from "./ConsultIntroduction.vue?vue&type=template&id=1f5c6bfc&"
import script from "./ConsultIntroduction.vue?vue&type=script&lang=js&"
export * from "./ConsultIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./ConsultIntroduction.vue?vue&type=style&index=0&id=1f5c6bfc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports